export class Status {
    constructor(
        public createdDate: string = "1900-01-01",
        public createdBy: string = "",
        public name: string = "",
        public description: string = "",
        public type: string = ""
    ){}
} 